import { useState, useEffect } from "react";

const WHATSAPP_NUMBER = "5511406340000";
const WHATSAPP_MESSAGE = "Olá! Gostaria de solicitar uma análise gratuita de seguro.";

export default function WhatsAppFloat() {
  const [visible, setVisible] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const [showCalcTooltip, setShowCalcTooltip] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 1500);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (visible) {
      const tooltipTimer = setTimeout(() => setShowTooltip(true), 2500);
      const hideTooltip = setTimeout(() => setShowTooltip(false), 6000);
      return () => {
        clearTimeout(tooltipTimer);
        clearTimeout(hideTooltip);
      };
    }
  }, [visible]);

  const handleWhatsApp = () => {
    const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const handleCalculadora = () => {
    const el = document.getElementById("calculadora");
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <div
      className={`fixed bottom-20 right-4 z-40 flex flex-col items-end gap-3 transition-all duration-500 md:bottom-24 md:right-6 md:z-50 ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10 pointer-events-none"
      }`}
    >
      {/* Tooltip WhatsApp */}
      <div
        className={`hidden md:block transition-all duration-300 ${
          showTooltip ? "opacity-100 translate-x-0" : "opacity-0 translate-x-4 pointer-events-none"
        }`}
      >
        <div className="bg-white text-gray-800 text-sm font-medium px-4 py-2.5 rounded-2xl shadow-xl border border-gray-100 whitespace-nowrap max-w-[220px]">
          <p className="leading-snug">💬 Fale com um especialista agora!</p>
          <div className="absolute right-4 bottom-[-6px] w-3 h-3 bg-white border-r border-b border-gray-100 rotate-45" />
        </div>
      </div>

      {/* Botão Calcular Economia */}
      <div className="flex items-center gap-2">
        {/* Tooltip Calculadora */}
        <div
          className={`hidden md:block transition-all duration-300 ${
            showCalcTooltip ? "opacity-100 translate-x-0" : "opacity-0 translate-x-4 pointer-events-none"
          }`}
        >
          <div className="bg-white text-gray-800 text-sm font-medium px-4 py-2.5 rounded-2xl shadow-xl border border-gray-100 whitespace-nowrap">
            <p className="leading-snug">🧮 Veja quanto você pode economizar!</p>
          </div>
        </div>

        <button
          onClick={handleCalculadora}
          onMouseEnter={() => setShowCalcTooltip(true)}
          onMouseLeave={() => setShowCalcTooltip(false)}
          aria-label="Calcular Economia"
          className="flex h-14 w-14 items-center justify-center gap-2 rounded-full p-0 text-sm font-semibold text-white shadow-2xl cursor-pointer transition-all duration-200 hover:scale-105 active:scale-95 whitespace-nowrap md:h-auto md:w-auto md:px-4 md:py-3"
          style={{
            background: 'var(--color-warning)',
            boxShadow: '0 6px 18px rgba(242, 140, 40, 0.35)'
          }}
        >
          <div className="w-5 h-5 flex items-center justify-center">
            <i className="ri-calculator-line text-lg" />
          </div>
          <span className="hidden md:inline">Calcular Economia</span>
        </button>
      </div>

      {/* Botão WhatsApp */}
      <button
        onClick={handleWhatsApp}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        aria-label="Falar no WhatsApp"
        className="relative w-14 h-14 rounded-full shadow-2xl flex items-center justify-center cursor-pointer transition-transform duration-200 hover:scale-110 active:scale-95"
        style={{ backgroundColor: "#25D366" }}
      >
        {/* Pulso animado */}
        <span
          className="absolute inset-0 rounded-full animate-ping opacity-30"
          style={{ backgroundColor: "#25D366" }}
        />
        <span
          className="absolute inset-0 rounded-full animate-ping opacity-20"
          style={{ backgroundColor: "#25D366", animationDelay: "0.5s" }}
        />

        {/* Ícone WhatsApp */}
        <div className="w-7 h-7 flex items-center justify-center relative z-10">
          <i className="ri-whatsapp-line text-white text-2xl" />
        </div>
      </button>
    </div>
  );
}